<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default table-default--40"
        :class="{'table-default--loading': table_preloader}"
      >
        <template #h__airline><div class="table-default__left">Airline</div></template>
        <template #h__supplier><div class="table-default__left">Supplier</div></template>
        <template #airline="{ row }">
          <div class="table-default__left">
            <router-link :to="{ name: 'hotels-airlines-general', params: { id: row.id } }" class="table-default__link-border">
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #supplier="{ row }"><div class="table-default__left">{{ row.supplier?.legal_name || '-' }}</div></template>
        <template #payment_method="{ row }">{{ row.supplier_payment_method?.payment_method.name || '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getDomesticFlightsAirlinesList } from '@/http'

export default {
  name: 'HotelsAirlinesList',
  data() {
    return {
      page_loaded: false,
      table_preloader: true,
      table: {
        items: [],
        columns: ['airline', 'supplier', 'payment_method'],
        options: {
          headings: {
            'airline': 'Airline',
            'supplier': 'Supplier',
            'payment_method': 'Supplier payment method',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getDomesticFlightsAirlinesList({page: this.pagination.page, page_size: 20})
        .then(res => {
          this.table.items = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.page_loaded = true
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
  }
}
</script>